import styles from './style.module.scss';
import DemoCard from '../demoCard';
import { src } from '/utils/common';
import { useState, useRef } from 'react';
import { WebPNativeImage } from '../../WebPImage';
import { useWebPResourceCompatibleFn } from '../../../hooks/useWebPResource';
import StreamLakeVideo from '@/components/StreamLakeVideo';
import usePolyfillVideo from '@/hooks/usePolyfillVideo';

const DemoPresentationPc = ({ demoList }) => {
  const [show, setShow] = useState(false);
  const videoRefs = useRef('');
  const shouldVideoPolyfill = usePolyfillVideo();
  const webPResourceHandleFn = useWebPResourceCompatibleFn();

  function handleFullScreen(status) {
    setShow(status);
  }
  return (
    <main className={styles.demo}>
      <header className={styles.title}>功能演示</header>
      <section className={styles.content}>
        {demoList.map((item, index) => (
          <div key={index} className={styles.item}>
            <DemoCard demoList={item} row={index % 2 ? 'odd' : 'even'} />
          </div>
        ))}
      </section>
      <section className={styles['content-mobile']}>
        {demoList.map((item, index) => (
          <div key={index} className={styles['list-container']}>
            <div className={styles['list-item']}>
              <WebPNativeImage
                src={src('/img/title-icon.webp')}
                className={styles['item-img']}
              />
              <span className={styles['list-item-header']}>
                {item.demoTitle}
              </span>
            </div>
            <div className={styles['video-wrapper']}>
              <StreamLakeVideo
                className={styles['video-item']}
                src={item.videoUrl}
                poster={webPResourceHandleFn(src(item.posterUrl))}
                ref={(el) => (videoRefs.current = el)}
                loop
                muted
                controls
                preload
                webkit-playsinline="true"
                playsInline="true"
                x5-playsinline="true"
                playInNewWindow={shouldVideoPolyfill}
                placeholderImg={webPResourceHandleFn(src(item.posterUrl))}
              />
            </div>
            <div className={styles['list-item-element']}>
              {item.demoDesc.map((item, index) => {
                return (
                  <div
                    key={item.title}
                    className={styles['list-item-container']}
                  >
                    <WebPNativeImage
                      src={src('/img/mobileCheck.webp')}
                      className={styles['list-item-img']}
                      alt="check"
                    />
                    <div className={styles['list-item-header']}>
                      <div className={styles['list-item-title']}>
                        {item.title}
                      </div>
                      <div className={styles['list-item-subtitle']}>
                        {item.subTitle}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </section>
    </main>
  );
};

export default DemoPresentationPc;
